import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Authentication } from './authentication.service';
import { ErrorHandlingService } from './error-handling.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private authService: Authentication,
    private errorHandlingService: ErrorHandlingService,
    private readonly router: Router,
  ) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authService.isTokenValid()) {
      return true;
    } else {
      this.errorHandlingService.notAuthenticated();
      return false;
    }
  }

  canActivateChild(): Observable<boolean> | Promise<boolean> | boolean {
    if (!location.href.split('/')[3]) {
      this.router.navigate(['/home']);
      return true;
    } else if (this.authService.isTokenValid()) {
      return true;
    } else {
      return this.authService.refreshTokenAndRetry().pipe(
        map((response) => {
          const newAccessToken = response.access_token;
          const newRefreshToken = response.refresh_token;
          this.authService.accessToken.next(newAccessToken);
          this.authService.refreshToken = newRefreshToken;
          localStorage.setItem('access_token_automap', newAccessToken);
          localStorage.setItem('refresh_token_automap', newRefreshToken);
          if (this.authService.isTokenValid()) {
            return true;
          }
          this.errorHandlingService.notAuthenticated();
          return false;
        }),
        catchError((error) => {
          this.errorHandlingService.handleError(error, error.url);
          return throwError(error);
        }),
      );
    }
  }

  canLoad(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authService.isTokenValid()) {
      return true;
    } else {
      return false;
    }
  }
}
